import { generateName } from "@common/Common";
import { CurrencyDenomination, TimeFrameGranularity } from "@common/types";
import { ProjectPlanReadModel } from "@Quest/ProjectPlans/readmodels";
import { ProjectPlanTemplateReadModel } from "@Quest/ProjectPlanTemplates/readmodels";

export class ProjectPlanEditorViewModel
{
    opened: boolean = false;
    confirmButtonLabel: string | null = null;
    modalTitle: string | null = null;

    id: string | null = null;
    name: string | null = null;
    duration: number | null = null;
    granularity: string | null = null;
    denomination: string | null = null;
    dueDate: string | null = null;

    showCreator(t: ProjectPlanTemplateReadModel | null)
    {
        this.id = null;
        this.name = t?.Name ?? generateName('Business case');
        this.duration = t?.DurationInMonths ?? 72;
        this.granularity = t?.Granularity ?? TimeFrameGranularity.Yearly;
        this.denomination = t?.Denomination ?? CurrencyDenomination.Million;

        this.dueDate = t?.SubmissionDueDate;

        this.modalTitle = "Create business case";
        this.confirmButtonLabel = "Create";
        this.opened = true;
    }

    showEditor(p: ProjectPlanReadModel)
    {
        this.id = p.Id;
        this.name = p.Name;
        this.duration = p.Duration;
        this.granularity = p.Granularity;
        this.denomination = p.Denomination;

        this.dueDate = p.SubmissionDueDate;

        this.modalTitle = "Edit business case";
        this.confirmButtonLabel = 'Update';
        this.opened = true;
    }

    close()
    {
        this.opened = false;

        this.id = null;
        this.name = null;
        this.duration = null;
        this.granularity = null;
        this.denomination = null;
    }
}

export class ProjectPlanEditorFormSubmitEventPayload
{
    id: string | null;
    planName: string;
    durationInMonths: number;
    granularity: string;
    denomination: string;
    submissionDueDateIsoString: string | null;

    constructor(id: string | null, planName: string, durationInMonths: number, granularity: string, denomination: string, submissionDueDateIsoString: string | null)
    {
        this.id = id;
        this.planName = planName;
        this.durationInMonths = durationInMonths;
        this.granularity = granularity;
        this.denomination = denomination;
        this.submissionDueDateIsoString = submissionDueDateIsoString;
    }
}